// Feedback while a guess is being sent, and when sending it fails. A failed
// guess swaps nothing (see the form's hx-status/hx-config in
// _input_guess.html), so the row stays filled in and Enter retries it.

import { showMessage } from './messages.js'

// Most guesses come back well within this, so the sending state is only
// shown for slow ones rather than flashing on every guess.
const SENDING_DELAY_MS = 200

// The form that sent the request, if it's one that plays the game (marked
// data-guess-request: the guess form, and the reveal form that swaps it).
// Read from the request rather than event.target, as htmx fires events on
// document once the form has been swapped out.
const getGuessForm = (event) => {
    const form = event.detail?.ctx?.sourceElement
    return form?.matches?.('[data-guess-request]') ? form : null
}

const offlineNotice = document.getElementById('offline-notice')

const updateOfflineNotice = () => {
    if (offlineNotice) offlineNotice.hidden = navigator.onLine
}

document.addEventListener('htmx:before:request', (event) => {
    const form = getGuessForm(event)
    if (!form) return

    // navigator.onLine is only trustworthy when false (true just means
    // there's a network, not that it reaches the server).
    if (!navigator.onLine) {
        event.preventDefault()
        showMessage("You're offline, reconnect to send your guess")
        return
    }

    form.sendingTimeout = setTimeout(() => {
        form.classList.add('guess-sending')
        form.setAttribute('aria-busy', 'true')
    }, SENDING_DELAY_MS)
})

document.addEventListener('htmx:finally:request', (event) => {
    const form = getGuessForm(event)
    if (!form) return
    clearTimeout(form.sendingTimeout)
    form.classList.remove('guess-sending')
    form.removeAttribute('aria-busy')
})

// The request never got a response: the connection dropped, or it timed out.
document.addEventListener('htmx:error', (event) => {
    if (!getGuessForm(event)) return
    showMessage("Couldn't send your guess, check your connection and try again")
})

// A 4xx/5xx response, e.g. an expired CSRF token or a server error.
document.addEventListener('htmx:response:error', (event) => {
    if (!getGuessForm(event)) return
    showMessage('Something went wrong, refresh the page and try again')
})

window.addEventListener('online', updateOfflineNotice)
window.addEventListener('offline', updateOfflineNotice)
updateOfflineNotice()
